<template>
    <div class="features-area pt-100 pb-70 bg-f4f6fc">
        <div class="container">
            <div class="section-header" data-aos="fade-up">
                <span class="section-tag">Warum Benovium</span>
                <h2>Ihre Vorteile</h2>
            </div>

            <div class="row">
                <div class="col-lg-4 col-sm-6" data-aos="fade-right" data-aos-delay="0">
                    <div class="single-features-box">
                        <div class="icon">
                            <i class='bx bxs-badge-check'></i>
                        </div>
                        <h3>IT-Lösungen</h3>
                        <p>Maßgeschneiderte IT-Lösungen, die perfekt auf Ihre Geschäftsanforderungen zugeschnitten sind.</p>
                    </div>
                </div>

                <div class="col-lg-4 col-sm-6" data-aos="fade-up" data-aos-delay="100">
                    <div class="single-features-box">
                        <div class="icon">
                            <i class='bx bx-cog'></i>
                        </div>
                        <h3>Flexible Funktionalität</h3>
                        <p>Anpassbare Systeme, die mit Ihrem Unternehmen wachsen und sich Ihren Bedürfnissen anpassen.</p>
                    </div>
                </div>

                <div class="col-lg-4 col-sm-6" data-aos="fade-left" data-aos-delay="200">
                    <div class="single-features-box">
                        <div class="icon">
                            <i class='bx bx-conversation'></i>
                        </div>
                        <h3>IT-Beratung</h3>
                        <p>Kompetente Beratung von erfahrenen Experten für Ihre digitale Strategie.</p>
                    </div>
                </div>

                <div class="col-lg-4 col-sm-6" data-aos="fade-right" data-aos-delay="300">
                    <div class="single-features-box">
                        <div class="icon">
                            <i class='bx bxs-user-check'></i>
                        </div>
                        <h3>Persönliche Betreuung</h3>
                        <p>Ein direkter Ansprechpartner für Ihr Projekt. Keine Warteschleifen, keine anonymen Tickets.</p>
                    </div>
                </div>

                <div class="col-lg-4 col-sm-6" data-aos="fade-up" data-aos-delay="400">
                    <div class="single-features-box">
                        <div class="icon">
                            <i class='bx bxs-bolt'></i>
                        </div>
                        <h3>Schnelle Umsetzung</h3>
                        <p>Effiziente Prozesse ohne Agentur-Overhead. Ihre Webseite ist in kürzester Zeit online.</p>
                    </div>
                </div>

                <div class="col-lg-4 col-sm-6" data-aos="fade-left" data-aos-delay="500">
                    <div class="single-features-box">
                        <div class="icon">
                            <i class='bx bxs-wrench'></i>
                        </div>
                        <h3>Wartung & Support</h3>
                        <p>Langfristige Betreuung nach Projektabschluss. Updates, Fehlerbehebung und technischer Support.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AmazingFeatures'
}
</script>